import React from 'react'
import Module, { ModuleProps } from './Module'
import { Typogaphy } from 'vnetwork-ui'

interface TabModulesProps {
    modules: ModuleProps[]
    className?: string
    title?: string
    gridCols?: number
}

const TabModules: React.FC<
    TabModulesProps & { onChangeTab: (tab: string) => void }
> = ({ modules, className = '', title, onChangeTab, gridCols = 4 }) => {
    return (
        <div className={`space-y-4 ${className} mb-2 mt-2`}>
            {title && (
                <Typogaphy className="text-lg font-semibold text-gray-900">
                    {title}
                </Typogaphy>
            )}
            <div
                className={`grid grid-cols-1 md:grid-cols-${gridCols} lg:grid-cols-${gridCols} gap-2`}
            >
                {modules.map((module) => (
                    <Module
                        key={module.value}
                        icon={module.icon}
                        label={module.label}
                        className={module.className}
                        value={module.value}
                        component={module.component}
                        onChangeTab={onChangeTab}
                    />
                ))}
            </div>
        </div>
    )
}

export default TabModules
